export default function FormFieldRowBarcode() {
  return null;
}
